module.exports = __webpack_public_path__ + "img/feizhu_logo.f6ed3524.png";